import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';


export class CreatePage extends PageBase<PageOptionsBase> {

    private _slctChannels: JQuery;
    private _chckAssignOperation: JQuery;


    constructor(options: PageOptionsBase) {
        super(options);
        this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
    }

    init(): void {
        this._slctChannels = Utils.getJQueryById('channels');
        this._slctChannels.multiselect('disable');
        this._chckAssignOperation = Utils.getJQueryById('IncludeOperation');
        this._chckAssignOperation.on('change', this.onCheckBoxChange);
    }

    private onCheckBoxChange(): void {
        if (this._chckAssignOperation.is(':checked')) {
            this._slctChannels.multiselect('enable');
        } else {
            this._slctChannels.multiselect('clearSelection');
            this._slctChannels.multiselect('disable');
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/CreatePage.ts
 **/